export const TabBarListTypeMap = {
  DEFAULT: 'tabBarNameList',
  FONT: 'editFontBarNamleList',
  IMG: 'editImgBarNameList',
  SPEAKER: 'editSpeakerBarNameList',
  BGMUSIC: 'editMusicList',
  TEXT_TEMPLATE: 'editTextTemplateList'
}

export const TabTypeMap = {
  COVER: 'cover',
  SUBTITLES: 'subtitles',
  SPEAKER: 'speaker',
  MUSIC: 'music',
  TEXT: 'text',
  EDITFONT: 'edit_font',
  FONT: 'font',
  STYLE: 'style',
  WORDPRON: 'word_pron',
  NUMPRON: 'num_pron',
  EDITIMG: 'edit_img',
  EDITSPEAKER: 'edit_speaker',
  DELFONT: 'delete_font',
  DELIMG: 'delete_img',
  DELETEVOLUME: 'delete_volume',
  VOLUME: 'volume',
  ADD_TEXT_CONTENT: 'add_text_content',
  EDIT_TEXT_CONTENT: 'edit_text_content',
  DELETE_TEXT_CONTENT: 'delete_text_content',
  EDIT_TEXT_CONTENT_STYLE: 'edit_text_content_style',
  EDIT_TEXT_TEMPLATE: 'edit_text_template',
  DELETE_TEXT_TEMPLATE: 'delete_text_template',
  BRAIN_TITLE: 'brain_title',
  SETCOVER: 'set_cover',
}
export const WHRATIO = {
  '16:9': {
    width: 7.5,
    height: 4.2
  },
  '4:3': {
    width: 7.5,
    height: 5.64

  },
  '3:4': {
    width: 5.4,
    height: 7.2

  },
  '1:1': {
    width: 6.4,
    height: 6.4

  },
  '9:16': {
    width: 4.04,
    height: 7.2

  }
}
export const GPWHRATIO = {
  '16:9': {
    width: 7.5,
    height: 4.2
  },
  '4:3': {
    width: 5.7,
    height: 4.28

  },
  '3:4': {
    width: 3.21,
    height: 4.28

  },
  '1:1': {
    width: 4.28,
    height: 4.28

  },
  '9:16': {
    width: 2.4,
    height: 4.28

  }
}
export const SCREENWHRATIO = {
  '16:9': {
    width: 7.5,
    height: 4.2
  },
  '4:3': {
    width: 7.5,
    height: 5.64

  },
  '3:4': {
    width: 7.5,
    height: 10

  },
  '1:1': {
    width: 7.5,
    height: 7.5

  },
  '9:16': {
    width: 7.08,
    height: 12.64

  }
}
function addGetSize(config) {
  Object.keys(config).forEach(key => {
    Object.defineProperty(config[key], 'size', {
      get(){
        const width = window.innerWidth * config[key].width / 7.5
        const [a, b] = key.split(':')
        return [width, width * +b / +a]
      }
    })
  })
}
addGetSize(WHRATIO)
addGetSize(GPWHRATIO)
addGetSize(SCREENWHRATIO)

// 字体预览和导出误差
const fontDeviation = [
  [300, 3],
  [414, 4],
  [600, 6], 
  [800, 8],  
  [1024, 8], 
  [1200, 11], 
  [1400, 14],
  [1600, 15],
  [1800,  16],
  [2000, 17],
]
export function getFontDeviation(canvaWidth){
  let res = 0, minDis = Infinity
  for(let [a,b] of fontDeviation){
    const dis = Math.abs(canvaWidth - a)
    if(dis < minDis){
      minDis = dis
      res = b
    }
  }
  return res
}

//转场时间
export const TRANSTIME = 500

// 屏幕分辨率
export const RESOLUTION = {
  '480p': 480,
  '720p': 720,
  '1080p': 1080,
  '2k/4k': 2000
}

// 默认字体大小
export const DEFAULTFONTSIZE = {
  '9:16': 3.1,
  '3:4': 4.3,
  '16:9': 12,
  '4:3': 8,
  '1:1': 5.9,
}